<template>
  <div :class="format" class="container-image-inline-item">
    <img :src="url" :class="align" />
    <div class="legend p-2" v-if="legend && desc">
      {{ legend }}
    </div>
  </div>
</template>

<style lang="scss">
  .container-image-inline-item {
    position: relative;
    left: -20%;
    width: 140%;
    height: auto;
    margin: 15px auto 55px auto;
    overflow: hidden;

    &.content-fit {
      left: 0%;
      width: 100%;
    }

    @media (max-width: 820px) {
      left: 0%;
      width: 100%;
    }

    img {
      display: block;
      align-items: center;
      justify-content: center;
      width: auto;
      max-width: 100%;

      &.right {
        object-position: right;
        object-fit: cover;
      }
    }

    .legend {
      padding: 5px;
      font-size: 14px;
      color: #818181;
      border-bottom: 1px solid #f1f1f1;
    }
  }
</style>

<script>
  export default {
    name: 'ImageInline',
    props: {
      src: {
        type: String,
        default: ``
      },
      desc: {
        type: Boolean,
        default: true
      },
      format: {
        type: String,
        default: `full-size`
      }
    },
    computed: {
      url() {
        const path = this.src.split('|')
        if(path[0])
          return path[0]
        return this.src
      },
      legend() {
        const path = this.src.split('|')
        if(path[1])
          return path[1]
        return ``
      },
      align() {
        const path = this.src.split('|')
        if(path[2])
          return path[2]
        return ``
      }
    }
  }
</script>